import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { FileInfo } from '@progress/kendo-angular-upload';
import { saveAs } from '@progress/kendo-file-saver';
import { ToastrService } from 'ngx-toastr';
import { of, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import * as _ from 'lodash';

import { AttachService, IMAGE_EXTENSIONS, PDF_EXTENSION } from '@app/shared/services/attach.service';
import { Attach } from '@app/shared/models/attach';

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileViewerComponent implements OnInit {
  fileFetching: boolean;
  downloadingIsActive: boolean;
  private subscription: Subscription;

  @Input() attach: Attach;

  constructor(private cd: ChangeDetectorRef, private toastr: ToastrService, private attachService: AttachService) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.fileFetching = this.isImage || this.isPdf;
  }

  get file(): FileInfo {
    return this.attach.fileInfo;
  }

  get isImage(): boolean {
    return (
      this.attach.mimeType?.toLowerCase().includes('image') ??
      IMAGE_EXTENSIONS.includes(this.file.extension.toLowerCase())
    );
  }

  get isPdf(): boolean {
    return this.file.extension.toLowerCase() === PDF_EXTENSION;
  }

  onFileLoad() {
    this.fileFetching = false;
    this.cd.markForCheck();
  }

  onFileLoadError(event: ErrorEvent) {
    this.toastr.error(event.message, `Ошибка при загрузке документа`);
    this.fileFetching = false;
    this.cd.markForCheck();
  }
  downloadFile() {
    const { attach } = this;
    const isNew = _.isNil(attach.id);
    const blob$ = isNew ? of(attach.fileInfo.rawFile) : this.attachService.getAttach(attach);
    this.downloadingIsActive = true;
    this.subscription.add(
      blob$
        .pipe(
          finalize(() => {
            this.downloadingIsActive = false;
            this.cd.markForCheck();
          }),
        )
        .subscribe(
          (response: Blob) => saveAs(response, attach.docName),
          (error: Error) => this.toastr.error(`Ошибка при загрузке файла: ${error.message ?? ''}`),
        ),
    );
  }
}
